// extracted by mini-css-extract-plugin
export default {"root":"RowWrap__root--iXkXRW"};